// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__aj-RC","show":"TutorialStyles_show__dHKSk","tutorial":"TutorialStyles_tutorial__mYg-o","skipCount":"TutorialStyles_skipCount__TySmy"};